const sources = {
  svga: {
    666: process.env.VUE_APP_STATIC_BASE + '/common-static/svga/1.0.0/666.svga',
    玫瑰: process.env.VUE_APP_STATIC_BASE + '/common-static/svga/1.0.0/flower.svga',
    咖啡: process.env.VUE_APP_STATIC_BASE + '/common-static/svga/1.0.0/coffee.svga',
    爱心: process.env.VUE_APP_STATIC_BASE + '/common-static/svga/1.0.0/love.svga',
    飞机: process.env.VUE_APP_STATIC_BASE + '/common-static/svga/1.0.0/plane.svga',
    火箭: process.env.VUE_APP_STATIC_BASE + '/common-static/svga/1.0.0/rocket.svga',
    汽车: process.env.VUE_APP_STATIC_BASE + '/common-static/svga/1.0.0/car.svga',
    礼炮: process.env.VUE_APP_STATIC_BASE + '/common-static/svga/1.0.0/fireworks.svga',
    打赏: process.env.VUE_APP_STATIC_BASE + '/common-static/svga/1.0.0/wallet.svga'
  },
  gift: {
    666: process.env.VUE_APP_STATIC_BASE + '/common-static/images/gift/666.png',
    reward: process.env.VUE_APP_STATIC_BASE + '/common-static/images/gift/reward.png',
    玫瑰: process.env.VUE_APP_STATIC_BASE + '/common-static/images/gift/flower.png',
    咖啡: process.env.VUE_APP_STATIC_BASE + '/common-static/images/gift/coffee.png',
    爱心: process.env.VUE_APP_STATIC_BASE + '/common-static/images/gift/love.png',
    飞机: process.env.VUE_APP_STATIC_BASE + '/common-static/images/gift/plane.png',
    火箭: process.env.VUE_APP_STATIC_BASE + '/common-static/images/gift/rocket.png',
    汽车: process.env.VUE_APP_STATIC_BASE + '/common-static/images/gift/car.png',
    礼炮: process.env.VUE_APP_STATIC_BASE + '/common-static/images/gift/fireworks.png'
  },
  chat: {
    666: process.env.VUE_APP_STATIC_BASE + '/common-static/images/chat/666.png',
    reward: process.env.VUE_APP_STATIC_BASE + '/common-static/images/chat/reward.png',
    玫瑰: process.env.VUE_APP_STATIC_BASE + '/common-static/images/chat/flower.png',
    咖啡: process.env.VUE_APP_STATIC_BASE + '/common-static/images/chat/coffee.png',
    爱心: process.env.VUE_APP_STATIC_BASE + '/common-static/images/chat/love.png',
    飞机: process.env.VUE_APP_STATIC_BASE + '/common-static/images/chat/plane.png',
    火箭: process.env.VUE_APP_STATIC_BASE + '/common-static/images/chat/rocket.png',
    汽车: process.env.VUE_APP_STATIC_BASE + '/common-static/images/chat/car.png',
    礼炮: process.env.VUE_APP_STATIC_BASE + '/common-static/images/chat/fireworks.png'
  }
};
export default sources;
